import store from './store';
import axios from 'axios';
import msg from '../messages';

export async function createToken(action, recaptcha_container, session) {
    let app_environment = store.state.appEnvironment;

    let token_generation_url;
    const full_domain = store.state.domainSlug === 'ips' ? 'iphonephotographyschool' : 'photographypro';
    if (app_environment === 'production') {
        token_generation_url = 'https://secure.' + full_domain + '.com/api/csrf?action=';
    } else if (app_environment === 'staging') {
        token_generation_url = 'https://staging-secure.' + full_domain + '.com/api/csrf?action=';
    } else {
        return {};
    }

    let response;
    let response_errors = [];
    let failed_count = 0;
    while (!response && failed_count < 3) {
        try {
            const sessionParam = session ? '&session=' + session : '';
            response = await axios.get(token_generation_url + action + sessionParam);
        } catch (err) {
            response_errors.push(err.message);
            failed_count++;
        }
    }
    if (!response) {
        logger.captureException(new Error(msg.csrf.fetchFailed), { extra: { response_errors } });

        return {
            // This will be included in the post to server.
            // Call will be denied because the token is missing but the server-side error logs
            // will contain all the information in request to understand what exactly happened
            'axios-calls-failed': response_errors,
            'axios-call-made-to-sp': true,
        };
    }

    let fields = {
        csrf_token: response.data.token,
    };

    if (failed_count > 0) {
        fields = Object.assign({}, fields, { failed_count });
    }

    if (response.data.recaptcha_required) {
        const recaptcha_token = await checkRecaptcha(recaptcha_container);
        // if this fails then it is reported in higher usage places
        fields = Object.assign({}, fields, { recaptcha_token });
    }

    return fields;
}

function checkRecaptcha(recaptcha_container) {
    return new Promise((resolve, reject) => {
        window.onRecaptchaLoaded = function () {
            $(recaptcha_container).append(
                '<div id="js--google-recaptcha-wrapper" class="google-recaptcha-wrapper">' +
                    '<p class="google-recaptcha-wrapper__p">Please confirm you\'re not a robot <br/>by checking the box below</p>' +
                    '<div id="google-recaptcha"></div>' +
                    '</div>',
            );
            grecaptcha.render('google-recaptcha', {
                sitekey: '6LeteckUAAAAABCkOBnT_9H1MWnYzgADYbFHuTsn',
                theme: 'light',
                callback: (response) => {
                    $('#js--google-recaptcha-wrapper').remove();
                    resolve(response);
                },
            });
        };

        let src = 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoaded&render=explicit';
        $('script[src="' + src + '"]').remove();
        $('<script>').attr('src', src).appendTo('head');
    });
}
